"use client";

import { useModal } from "@/components/ModalContext";
import InfoIcon from "@/components/icons/InfoIcon";

const GalleryBadgeTooltip = ({ badge }) => {
  const { openModal } = useModal();
  // Absolutely positioned by this component
  if (!badge) return null;

  const badgeClassName =
    "absolute top-4 right-4 z-10 flex items-center justify-end gap-2 whitespace-nowrap bg-warm-white px-4 py-2 font-worksans text-xs leading-normal font-normal text-primary shadow-[0px_4px_16px_rgba(0,0,0,0.16)]";

  // BL-971: without Delivery Message copy in Contentstack there is nothing to
  // open, so the label shows on its own, with no icon promising a modal.
  if (!badge.html) {
    return <p className={`${badgeClassName} m-0`}>{badge.label}</p>;
  }

  // BL-971: the Shopify label heads the modal, the Contentstack copy follows.
  const openDetails = () =>
    openModal(
      <div className="px-12 py-16 text-center font-worksans text-base leading-relaxed text-primary">
        <p className="mb-4 font-bold">{badge.label}</p>
        <div
          className="rte-content rte-content--light [&_h2]:[font-family:var(--font-cormorant)] [&_h2]:font-normal [&_p]:mb-4 [&_p:last-child]:mb-0"
          dangerouslySetInnerHTML={{ __html: badge.html }}
        />
      </div>,
      "max-w-3xl",
      "bg-warm-white",
      { ariaLabel: badge.label },
    );

  return (
    <button
      type="button"
      onClick={openDetails}
      aria-haspopup="dialog"
      className={`group ${badgeClassName} cursor-pointer`}
    >
      {badge.label}
      {/* BL-807: the shared icon supplies both halves of this — the upright
          sans-serif glyph the comp calls for, and the outline-to-solid green
          crossfade on hover. `group` on the button makes the whole banner the
          hover target, matching the pill and pitstop in the buy box.
          BL-821: `block` takes the svg out of the inline flow. Left inline it
          sits on the text baseline, which pads the icon's box with descender
          space (inflating the banner past the comp height) and drops it a few
          px below the `inset-0` hover copy, so the crossfade visibly jumps. */}
      <InfoIcon className="block size-4" />
    </button>
  );
};

export default GalleryBadgeTooltip;
